import { UsersParams } from '../types/types';

export const userQueryKeys = {
  all: ['users'],
  list: (params?: UsersParams) => [...userQueryKeys.all, params] as const,
  me: () => [...userQueryKeys.all, 'me'] as const,
  workspaces: () => [...userQueryKeys.list(), 'workspaces'] as const,
  workspace: (workspaceId: string | null | undefined) => [
    ...userQueryKeys.workspaces(),
    workspaceId,
  ],
  details: () => [...userQueryKeys.list(), 'detail'] as const,
  detail: (id?: string) => [...userQueryKeys.details(), id] as const,
  role: (id?: string) => [...userQueryKeys.detail(id), 'role'] as const,
};
